// extracted by mini-css-extract-plugin
export default {"card":"n5-z"};